export default __webpack_public_path__ + "static/media/Saira_SemiExpanded-SemiBold.bf7ae139.ttf";